import { useEffect, useState } from 'react';
import styles from './UpperContentSubCategory.module.css';
import { ISubCategoryData } from '@/interfaces';
import sortItems from '../../../../data/marketPlaceSortItems.json';
import { pushRoute } from '@/lib/helpers/common';
import { useRouter } from 'next/router';
import { useGlobalContext } from '@/lib/context';
type props = {
    data: ISubCategoryData
    checkedAtrributes: [{ AttributeNameSlug: string, AttributeValueSlug: string }],
    handleAttributes: Function,
    handleSort: Function,
    activeSort: string,
    productCount: number,
    priceFilter: { prevMinPrice: number, prevMaxPrice: number, minPrice: number, maxPrice: number }
}
export function UpperContentSubCategory({ data, checkedAtrributes, handleAttributes, handleSort, activeSort, productCount, priceFilter }: props) {
    const [active, setActive] = useState(false);
    const [fullDesc, setFullDesc] = useState(false);
    const router = useRouter();
    const { props: { isAppView } } = useGlobalContext();
    useEffect(() => {
        const handleClick = (event: any) => {
            event.target.id != 'sortDropDown' && setActive(false);
        };
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);
    const pageNo = data?.pagination?.pageNo || 0;

    const getPriceUrl = () => {
        let navigateUrl = "";
        const baseUrl = `${process.env.SITE_URL}/online-store/${data.serviceSlug}/${data.categorySlug}`;
        if (checkedAtrributes && Object.keys(checkedAtrributes).length == 0) {
            navigateUrl = baseUrl;
        } else if (checkedAtrributes && Object.keys(checkedAtrributes).length == 1) {
            const isUrlFilter = data.filters.find((f: any) => f.isGenerateFilterUrl == 1 && checkedAtrributes[0].AttributeNameSlug == f.attributeNameSlug);
            if (isUrlFilter) {
                navigateUrl = `${process.env.SITE_URL}/online-store/${isUrlFilter.attributeValues[0].attributeValueSlug}-online-${data.categorySlug}-${data.categoryIdentifier}-${isUrlFilter.attributeId}`
            } else {
                const otherParams = Object.entries(router.query).filter(([key]: any) => key != 'min-price' && key != 'max-price').map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                navigateUrl = `${baseUrl}/search?${otherParams}`
            }
        } else {
            const otherParams = Object.entries(router.query).filter(([key]: any) => key != 'min-price' && key != 'max-price')
                .map(([key, value]: any) => `${key}=${encodeURIComponent(value)}`)
                .join('&');
            navigateUrl = `${baseUrl}/search?${otherParams}`
        }
        pushRoute(navigateUrl);
    };

    return (
        <>
            <div className={styles.topSectionBox} style={isAppView ? { paddingTop: '35px' } : {}}>
                <div className={`${styles.containerFull} containerFull`}>
                    <div className={`${styles.modularHeading} modularHeading`}>
                        <h1 className={`${styles.mainHeading} mainHeading font24  text000 mb10 f600`}>{(pageNo > 1 ? `Page ${pageNo} - ` : '') + (data?.metaDetails?.heading || "")}</h1>
                        <span className={`font12 f500 font666`}>{`(${productCount} Products)`}</span>
                    </div>
                    <div className={`${styles.readMoreHeading} ${fullDesc && styles.active}`}>
                        <p className={`${styles.subHeading} font16 text666`}>{data?.metaDetails?.short_content || ""}</p>
                        {(data.metaDetails?.short_content && data.metaDetails?.short_content.length > 190) && <span onClick={() => setFullDesc(!fullDesc)}>read {fullDesc ? 'less' : 'more'}</span>}
                    </div>


                </div>
            </div>
            <div className={styles.clearSortMain}>
                <div className={styles.clearFilterBox}>
                    <span className="font12 text000 f600">Filters</span>
                    <div className={styles.filtClear}>
                        <ul className={styles.chipsBx}>
                            {
                                checkedAtrributes && checkedAtrributes.map((f, idx) => <li key={idx}>{f.AttributeValueSlug.slugToText()}<span onClick={(e) => handleAttributes(e, f)}></span> </li>)
                            }
                            {(priceFilter.minPrice != priceFilter.prevMinPrice || priceFilter.maxPrice != priceFilter.prevMaxPrice) && <li key={'priceFilter'}>₹{priceFilter.minPrice} - ₹{priceFilter.maxPrice}<span onClick={getPriceUrl}></span> </li>}
                            {(checkedAtrributes.length > 0 || priceFilter.minPrice != priceFilter.prevMinPrice || priceFilter.maxPrice != priceFilter.prevMaxPrice) && <li className={styles.clearAll} onClick={(e) => pushRoute(`/online-store/${data.serviceSlug}/${data.categorySlug}`)}>Clear All</li>}
                        </ul>
                    </div>
                </div>
                <div className={`${styles.sortByBox} ${active && styles.active}`} onClick={() => setActive(true)}>
                    {/* <!-- add active className --> */}
                    <button className={styles.dropbtn} id="sortDropDown">
                        <span>Sort By:</span>{sortItems.find((f) => f.key === activeSort)?.value}
                        <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m1 13 6-6-6-6" stroke="#222" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>
                    </button>
                    <div className={styles.dropdownContent}>
                        <ul>
                            {
                                sortItems.map((f, idx) =>
                                    <li key={idx} value={f.key} onClick={() => handleSort(f.key)}>{f.value}</li>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}